import { AdblockDetector } from 'adblock-detector';

export default {
  namespaced: true,
  state: {
    detected: false,
  },
  mutations: {
    SET_ADBLOCK_DETECTED(state, value) {
      state.detected = value;
    },
  },
  actions: {
    check({ commit }) {
      commit('SET_ADBLOCK_DETECTED', new AdblockDetector().detect());
    },
  },
};
